var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduationCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graduation-cap",
    clipPath: "url(#clip0_2471_8604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector",
    filter: "url(#filter0_bdi_2471_8604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53767 16.6156C4.9321 16.2933 4.9321 15.3734 5.53767 15.051L19.0304 7.86935C19.9556 7.37688 21.0447 7.37688 21.9699 7.86935L35.4627 15.051C36.0682 15.3734 36.0682 16.2933 35.4627 16.6156L21.9699 23.7973C21.0447 24.2898 19.9556 24.2898 19.0304 23.7973L5.53767 16.6156Z",
    fill: "white",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M10.5 21.145L18.2472 25.2686C19.6619 26.0216 21.3381 26.0216 22.7528 25.2686L30.5 21.145V27.9198C30.5 32.4583 23.5001 32.5 20.5 32.5C17.4999 32.5 10.5 32.4583 10.5 27.9198V21.145Z",
    fill: "#7750E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9222 14.8816C25.9877 14.1943 26.5979 13.6903 27.2851 13.7557L36.0351 14.5891C36.6766 14.6502 37.1666 15.189 37.1666 15.8334V25.0001C37.1666 25.6904 36.6069 26.2501 35.9166 26.2501C35.2262 26.2501 34.6666 25.6904 34.6666 25.0001V16.97L27.0481 16.2445C26.3608 16.179 25.8568 15.5688 25.9222 14.8816Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_2471_8604",
    x: -14.9165,
    y: -2.5,
    width: 70.8335,
    height: 56.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2471_8604"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2471_8604",
    result: "effect2_dropShadow_2471_8604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2471_8604",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2471_8604"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2471_8604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/graduation-cap.dfc88cc054a5ba15d8c885d7491db549.svg";
export { ForwardRef as ReactComponent };